// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"99a84d47","977":"df915fe6"}[chunkId] + ".chunk.js";
};